var _a;
import { handleActions } from 'redux-actions';
import { NAMES } from '../actions/full-screen-modal';
export default handleActions((_a = {},
    _a[NAMES.OPEN_FULL_SCREEN_MODAL_VIDEO] = function () { return ({ lightbox: true }); },
    _a[NAMES.CLOSE_FULL_SCREEN_MODAL_VIDEO] = function () { return ({ lightbox: false }); },
    _a), {});
